import { Component, OnChanges, Input } from '@angular/core';
import { OrderService } from 'src/app/services/api/order.service';
import { LangService } from 'src/app/services/lang/lang.service';
import { FirebaseService } from 'src/app/services/firebase.service';
import { WinService } from 'src/app/services/win.service';
import { environment as env } from 'src/environments/environment';

@Component({
  selector: 'app-messaging',
  templateUrl: './messaging.component.html',
  styleUrls: ['./messaging.component.scss']
})
export class MessagingComponent implements OnChanges {

	@Input() orderId: any = null;
	@Input() qouteItemId: any = null;
	@Input() order: any = null;
	@Input() item: any = null;

	config: any = null;

	currentPage: any = 1;
	messages: any = null;
	newMessage:any = '';
	msgUrl: any = ''

	/* attachment */
	fileName: any = null;
	file: any = null;
	attachmentName: any;


	constructor(
		public winService: WinService,
    	public lang : LangService,
    	public firebaseService: FirebaseService,
    	public orderService : OrderService
	) {
		this.msgUrl = '/rest/entrelable/V1/lns-orderattachment/messages/'+this.orderId+'/'+this.qouteItemId+'/';
	 }

	ngOnChanges() {
		this.msgUrl = '/rest/entrelable/V1/lns-orderattachment/messages/'+this.orderId+'/'+this.qouteItemId+'/';
		this.getMessage().then(res => {
			this.scrollToBottom();
		});

		this.orderService.makeRequest('/rest/entrelable/V1/lns-orderattachment/config', '', 'GET').then(config => {
			this.config = config[0];
		});
	}

	ngOnInit() {
	}

	/**
	 * fetch all message from api limit is 10 per page
	 */
	getMessage(){
		return new Promise(resolve => {
			if(this.orderId && this.qouteItemId){
				let url = this.msgUrl+this.currentPage;
				this.orderService.makeRequest(url, '', 'GET').then(messages => {
					if(messages){
						let msgs: any = messages;
						if(!this.messages){
							this.messages = [];
						}
						msgs.forEach(msg => {
							this.messages.unshift(msg);
						});
					} else {
						this.orderService.toastService.add(this.lang.getLang('l90a'), 'danger');
					}
					resolve(messages);
				});
			} else {
				resolve(null);
			}
		});
	}

	/**
	 * open the file browser to prepare upload
	 */
	openFileBrowser(event: any){
		event.preventDefault();
		let el: HTMLElement = document.getElementById('attachment_input') as HTMLElement;
		el.click();
	}

	/**
	 * prepare the file to be uploaded on firestore
	 */
	prepareFile(event){
		let fName = event.target.files[0].name;
		let ext = fName.split('.');
		ext = ext[ext.length - 1];
		ext = ext.toLowerCase();
		this.orderService.attachmentName = fName;
		
		
		
		if(this.config.accepted_file_type[ext]){
			this.orderService.fileName = fName;
			this.orderService.file = event;
		} else {
			this.orderService.fileName = null;
			this.orderService.file = null;
			let types: any = [];
			for (var key in this.config.accepted_file_type) {
			    if (this.config.accepted_file_type.hasOwnProperty(key)) {
			        types.push(key);
			    }
			}
			types = types.join(', ');
			this.orderService.toastService.add('Please upload ' + types + ' only', 'danger');
		}
	}

	directUpload(event) {
		let fName = event.target.files[0].name;
		let ext = fName.split('.');
		ext = ext[ext.length - 1];
		ext = ext.toLowerCase();
		this.orderService.attachmentName = fName;
		
		if(this.config.accepted_file_type[ext]){
			this.orderService.fileName = fName;
			this.orderService.file = event;	
		} 
		else {
			this.fileName = null;
			this.file = null;
			let types: any = [];
			for (var key in this.config.accepted_file_type) {
			    if (this.config.accepted_file_type.hasOwnProperty(key)) {
			        types.push(key);
			    }
			}
			types = types.join(', ');
			this.orderService.toastService.add('Please upload ' + types + ' only', 'danger');
		}
	}

	/**
	 * send new message
	 */
	sendMessage(){
		let formData = new FormData();
		if(this.newMessage.length > 0){
			formData.append('message', this.newMessage);
			formData.append('order_id', this.order.entity_id);

			if(this.orderService.file){
				let path = env.firebase_path_prefix + 'messages/quote_'+this.order.quote_id+'/attachment_' + this.qouteItemId + '/';
				formData.append('path', path);
				formData.append('attachment', this.orderService.file.target.files[0]);
			}

			this.orderService.storage.get('user').then(user => {
				let ajaxData = {
					method: 'POST',
					headers: {
						"Authorization": 'Bearer ' + user['token']
					},
					url: this.orderService.getUrl(this.msgUrl),
					data: formData,
					error: error => {
					},
					success: message => {
						if(!this.messages){
							this.messages = message;
						} else {
							this.messages.push(message[0]);
						}
					},
					complete: complete => {
						this.newMessage = '';
						this.orderService.file = null;
						this.orderService.attachmentName = null;
						this.orderService.setLoader(false);
						this.scrollToBottom();
					},
					uploadProgress: (e, uploadProgress) => {
						// firebaseService.uploadProgress = uploadProgress;
					}
				}
				this.orderService.ajax(ajaxData);
			});
		}
	}

	/**
	 * start upload to google fire store
	 * return promise
	 */
	upload() {
		this.orderService.setLoader(true);
		return new Promise(resolve => {
			this.firebaseService
			.setFile(this.orderService.file)
			.setPath('messages/quote_'+this.order.quote_id+'/attachment_' + this.qouteItemId + '/')
			.getGenerateName().then(filename => {
				this.firebaseService.upload().then(url => {
					if(url){
						resolve(url);
					} else {
						resolve(null);
					}
				});
			});
		});
	}

	/**
	 * trigger the infinite scroll whenever it is possible
	 */
	onScrollUp(elem){
		this.currentPage++;
		this.getMessage().then(res => {});
	}

	/**
	 * scroll the content to the bottom of an element
	 */
	scrollToBottom(id:any = 'messages'){
		setTimeout(f => {
			try {
				var div = document.getElementById(id);
				div.scrollTop = div.scrollHeight - div.clientHeight;
			} 
			catch (error) {
				/** do nothing here */
			}
		}, 500);
	}

	get isApproved() {
		/*this.item.attachment.approved*/
	    let approved = false;
	    if(this.item){
			if(this.item.attachment) {
				if(this.item.attachment.approved == 'yes') {
					approved = true;
				}
			}
	    }

	    return approved;
	}

	get isComplete() {
		/*this.item.attachment.approved*/
	    let complete = false;
	    if(this.order){
			if(this.order.status == 'complete') {
				complete = true;
			}
	    }

	    return complete;
	}
}
